import * as tslib_1 from "tslib";
import selectShowPreviewTextOption from '../actions/selectShowPreviewTextOption';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var MessagePreviewFull = /** @class */ (function (_super) {
    tslib_1.__extends(MessagePreviewFull, _super);
    function MessagePreviewFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onShowPreviewTextChange = function (ev, option) {
            selectShowPreviewTextOption(option.key === 'true');
        };
        return _this;
    }
    MessagePreviewFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var showPreviewText = getFallbackValueIfNull(optionStore.showPreviewTextInListView, userOptions.ShowPreviewTextInListView);
        return (React.createElement(ChoiceGroup, { selectedKey: "" + showPreviewText, options: [
                {
                    key: 'true',
                    text: strings.options_messageList_previewShow,
                },
                {
                    key: 'false',
                    text: strings.options_messageList_previewHide,
                },
            ], onChange: this.onShowPreviewTextChange, label: strings.options_messageList_previewLabel }));
    };
    MessagePreviewFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], MessagePreviewFull);
    return MessagePreviewFull;
}(React.Component));
export default MessagePreviewFull;
//# sourceMappingURL=MessagePreviewFull.js.map